import { render, staticRenderFns } from "./section-blog-list.vue?vue&type=template&id=15f203f0&scoped=true&"
import script from "./section-blog-list.vue?vue&type=script&lang=js&"
export * from "./section-blog-list.vue?vue&type=script&lang=js&"
import style0 from "./section-blog-list.vue?vue&type=style&index=0&id=15f203f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f203f0",
  null
  
)

export default component.exports